import { MarkdownDocs } from '@mui/internal-core-docs/MarkdownDocs';
import * as pageProps from 'docs/data/migration/migration-charts-v8/migration-charts-v8.md?muiMarkdown';

export default function Page() {
  return <MarkdownDocs {...pageProps} />;
}
